import { Link } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { Button } from '@/components/ui';

export default function ForbiddenPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50">
      <div className="text-center max-w-md px-4">
        <div className="flex justify-center mb-6">
          <ShieldX className="h-24 w-24 text-neutral-400" />
        </div>
        <h1 className="text-3xl font-bold text-neutral-900 mb-2">Acces refuse</h1>
        <p className="text-lg text-neutral-600 mb-8">
          Vous n'avez pas les droits necessaires pour acceder a cette page.
        </p>
        <Link to="/">
          <Button variant="primary" size="lg">
            Retour au tableau de bord
          </Button>
        </Link>
      </div>
    </div>
  );
}
